import { createSelector } from 'reselect';

// Config
import { getConfigFeaturesSelector } from '@redux/reducers/config/configSelector';
import {
  getConfirmationIsClickCollectOrderSelector,
  getConfirmationIsMultiBatchSelector,
  getConfirmationOrderAmountsSelector,
  getConfirmationOrderDeliveriesSelector,
} from '@redux/reducers/confirmation/orderConfirmationSelector';
import {
  getApplyRewardsApiCallActiveSelector,
  getOrderFormAmountsSelector,
  getOrderFormIsClickCollectOrderSelector,
  getOrderFormIsGiftReceiptOrderSelector,
} from '@redux/reducers/order-form/orderFormSelector';

const orderTotalsOrderFormState = createSelector(
  [
    getOrderFormAmountsSelector,
    getOrderFormIsGiftReceiptOrderSelector,
    getOrderFormIsClickCollectOrderSelector,
    getApplyRewardsApiCallActiveSelector,
    getConfigFeaturesSelector,
  ],
  (amounts, isGiftReceiptOrder, isClickCollectOrder, applyRewardsApiCallActive) => ({
    amounts,
    applyRewardsApiCallActive,
    isGiftReceiptOrder,
    isClickCollectOrder,
  }),
);

const orderTotalsConfirmationPagePropsState = createSelector(
  [
    getConfirmationOrderAmountsSelector,
    getConfirmationIsMultiBatchSelector,
    getConfirmationOrderDeliveriesSelector,
    getConfirmationIsClickCollectOrderSelector,
    getApplyRewardsApiCallActiveSelector,
    getConfigFeaturesSelector,
  ],
  (amounts, isMultiBatch, deliveries, isClickCollectOrder, applyRewardsApiCallActive) => ({
    amounts,
    applyRewardsApiCallActive,
    isGiftReceiptOrder: !isMultiBatch && deliveries?.some((delivery) => delivery.isGiftReceiptOrder),
    isClickCollectOrder,
  }),
);

export { orderTotalsConfirmationPagePropsState, orderTotalsOrderFormState };
